var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79997 1H7.19993C4.18288 1 2.67436 1 1.73708 1.93728C0.799805 2.87456 0.799805 4.38308 0.799805 7.40013V10.6002C0.799805 13.6172 0.799805 15.1258 1.73708 16.063C2.67436 17.0003 4.18288 17.0003 7.19993 17.0003H8.79997C11.817 17.0003 13.3256 17.0003 14.2628 16.063C15.2001 15.1258 15.2001 13.6172 15.2001 10.6002V7.40013C15.2001 4.38308 15.2001 2.87456 14.2628 1.93728C13.3256 1 11.817 1 8.79997 1Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2001 9H0.799805",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 5H5.59985",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 13H5.59985",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingActive);
export default __webpack_public_path__ + "static/media/listing-active.89c2bfb6536370a3141e8c0a4854716e.svg";
export { ForwardRef as ReactComponent };